import * as React from "react"
import { useContext } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  MenuItem,
  Box,
  Typography,
  Button,
  Toolbar,
} from "@mui/material"
import BackIcon from "@mui/icons-material/ArrowBack"
import AutocompleteField from "../Trip/AutoCompleteField"
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js"
import api from "../../../apiConfig"

export default function PaymentAddNew() {
  const navigate = useNavigate()
  const [editedData, setEditedData] = React.useState({})

  const handleSaveClick = () => {
    if (editedData.driver_id && editedData.amount_lkr) {
      const data = {
        driverId: editedData.driver_id.driverId,
        amount: Number(editedData.amount_lkr),
        note: editedData.notes,
      }
      console.log("Save clicked", editedData)
      api
        .post("api/v1/companychargesettlement", data)
        .then((response) => {
          console.log("Response:", response)
          navigate("/wp-admin/payment")
        })
        .catch((error) => {
          console.error("Error saving data", error)
        })
    }
  }

  const createData = [
    {
      id: "driver_id",
      numeric: false,
      disablePadding: true,
      label: "Driver Name",
      type: "autocomplete",
    },
    {
      id: "amount_lkr",
      type: "number",
      numeric: true,
      disablePadding: false,
      label: "Amount (in LKR)",
    },
    { id: "notes", numeric: false, disablePadding: false, label: "Notes" },
  ]

  const handleChange = (event) => {
    const { name, value } = event.target
    setEditedData({ ...editedData, [name]: value })
  }

  const renderInputField = (key) => {
    const headCell = createData.find((cell) => cell.id === key)
    if (!headCell) return null

    switch (headCell.type) {
      case "autocomplete":
        return (
          <AutocompleteField
            label={headCell.label}
            endpoint="/api/v1/driver/list"
            onSelectionChange={(value) => {
              setEditedData({ ...editedData, [key]: value })
            }}
            value={editedData[key]}
          />
        )
      case "number":
        return (
          <TextField
            type="number"
            name={key}
            value={editedData[key] || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            size="small"
          />
        )
      case "string":
        return (
          <TextField
            type="text"
            name={key}
            value={editedData[key] || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            size="small"
          />
        )
      case "datetime":
        return (
          <TextField
            type="datetime-local"
            name={key}
            value={editedData[key] || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            size="small"
          />
        )
      case "enum":
        return (
          <TextField
            select
            name={key}
            value={editedData[key] || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            size="small"
          >
            {headCell.enum.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        )
      default:
        return (
          <TextField
            type="text"
            name={key}
            disabled={headCell.disabled}
            value={editedData[key] || ""}
            onChange={handleChange}
            fullWidth
            variant="outlined"
            size="small"
          />
        )
    }
  }

  if (!createData) {
    return <Typography>No data available to add a new trip.</Typography>
  }

  return (
    <Box>
      <Toolbar>
        <Button color="inherit" onClick={() => navigate(`/wp-admin/payment`)}>
          <BackIcon />
        </Button>

        <Typography variant="h6" gutterBottom>
          Add New Payment
        </Typography>
      </Toolbar>
      <Table>
        <TableBody>
          {createData.map((cell) => (
            <TableRow key={cell.id}>
              <TableCell component="th" scope="row">
                {cell.label}
              </TableCell>
              <TableCell>{renderInputField(cell.id)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box mt={2}>
        <Button variant="contained" color="primary" onClick={handleSaveClick}>
          Save
        </Button>
      </Box>
    </Box>
  )
}
